export const config = {
    getMySchool: "https://api-schoolmanagement.vihaaninnovations.com",
    // getMySchool: "http://localhost:8080",
    // getMySchool: "", // Use proxy in package.json
    // getMySchool: "http://192.168.0.37:8080",
    cookieName: "org_user",
    sessionCookie: "org_sess",
};